module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/10b8554664fe16cf03ad689126d24955.png";